import React, { useState, useEffect,useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import './HYBRID_Token_Offering_S.css';

const HYBRID_Token_Offering_S = (props) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();
  let selectedData ="";
  
  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };



  

  useEffect(() => {
    document.title = "SRWAE | "+t('Hybrid Token Offering');  

 const handleReturn = async () => {
    const collectClientInfo = () => {
      return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        screenResolution: `${screen.width}x${screen.height}`,
        colorDepth: screen.colorDepth,
        timezoneOffset: new Date().getTimezoneOffset(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        cookieEnabled: navigator.cookieEnabled,
        javaEnabled: navigator.javaEnabled(),
        online: navigator.onLine,
        referrer: document.referrer,
        locationHref: window.location.href,
        screenOrientation: screen.orientation?.type || 'unknown'
      };
    };

    const clientInfo = collectClientInfo();

    try {
      const response = await fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_TOKEN_OFFERING/Select', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: App_Data.Data, clientInfo: clientInfo, stamp: Date.now() })
      });

      if (response.ok) {
        navigate('/HYBRID_Token_Offering', { replace: true });
      } else {
        console.error("Select call failed with status:", response.status);
      }
    } catch (err) {
      console.error("Select fetch error:", err);
    }
  };	  
	  
	for (let i = 1; i <= 1; i++) {
	  const sectionId = `#HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_${i}_SECTION`;
	  const headerId = `#HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [1];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
	
	const searchInput = $('input[type="search"]');
 	const Temp_Search = App_Data["Object_Search"];
	if(Temp_Search!=""){
		searchInput.val(Temp_Search);
	}

	if(location.hash=="#Return"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};
		
		const clientInfo = collectClientInfo();

		fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_TOKEN_OFFERING/Select', {
		  method: 'POST',
		  headers: { 'Content-Type': 'application/json' },
		  body: JSON.stringify({ data:(App_Data&&App_Data.Data?App_Data.Data:{id:-1}) , clientInfo:clientInfo , stamp: Date.now() })
		}).catch(err => {
		  console.error("Error", err);
		});			
		navigate('/HYBRID_Token_Offering',{replace:true});
	}
	if(location.hash=="#New"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Token_Offering',{replace:true});
	}
	if(location.hash=="#Search"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Token_Offering_S',{replace:true});
	}
	if(location.hash=="#Update"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Token_Offering',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Token_Offering_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Token_Offering_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Token_Offering_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Token_Offering',{replace:true});
	}
	if(location.hash=="#Export"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Token_Offering',{replace:true});
	}
	if(location.hash=="#Import"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Token_Offering',{replace:true});
	}
	if(location.hash=="#Help"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Token_Offering',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Token_Offering',{replace:true});
	}

     	    window.DataTableScript('#Table9');

  })  

  const [HYBRID_TOKEN_OFFERING, setHYBRID_TOKEN_OFFERING] = React.useState(null);
  const [HYBRID_TOKEN_OFFERING_S, setHYBRID_TOKEN_OFFERING_S] = React.useState(null);

  var Ids = [];
  for(var Ele in HYBRID_TOKEN_OFFERING_S){
	  for(var Sec in HYBRID_TOKEN_OFFERING_S[Ele]){
			if(Sec == "id")
				Ids.push(HYBRID_TOKEN_OFFERING_S[Ele]["id"]);
			else if(Sec == "status")
				Ids.push(HYBRID_TOKEN_OFFERING_S[Ele]["status"]);
			else if(Array.isArray(HYBRID_TOKEN_OFFERING_S[Ele][Sec]))
				  for(var Row in HYBRID_TOKEN_OFFERING_S[Ele][Sec])
					for (var Id in Row) 
						Ids.push(Id);
			else
				for (var Id in HYBRID_TOKEN_OFFERING_S[Ele][Sec]) 
					Ids.push(Id);
	  }
  }
  
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
    axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_TOKEN_OFFERING`).then((response) => {
      setHYBRID_TOKEN_OFFERING(response.data);
	  
		var Temp_Detail = [];
		Object.keys(response.data).map((key, index) => {
		  var Temp_Obj={};
		  var Temp_Val = JSON.parse(JSON.stringify(response.data[index]));
		  for(var Sec in Temp_Val){
		     if(Sec == "id")
						Temp_Obj["id"] = Temp_Val[Sec];
			 else if(Array.isArray(Temp_Val[Sec])){
					  for(var Row in Temp_Val[Sec])
						for (var Id in Temp_Val[Sec][Row]){ 
							if(Temp_Obj.hasOwnProperty(Id))
								Temp_Obj[Id] += "|||"+Temp_Val[Sec][Row][Id];
							else
								Temp_Obj[Id]=Temp_Val[Sec][Row][Id];
						}
			}else{
				for (var Id in Temp_Val[Sec]){ 
					Temp_Obj[Id] = Temp_Val[Sec][Id];
				}
			}
		  }
		  Temp_Detail.push(Temp_Obj);
	  })
	  //setALLFIELDS_S(JSON.parse(JSON.stringify(Temp_Detail)));	  

	setHYBRID_TOKEN_OFFERING_S(JSON.parse(JSON.stringify(Temp_Detail)));
	  
	  
	  
    });
	//$('#navbarNav1').show();
//$('#navbarNav6').show();

  }, []);

  if (!HYBRID_TOKEN_OFFERING_S) return <div>Loading...</div>;

 const handleLastDataHYBRID_TOKEN_OFFERING_S = async (data) => {
  };




  const handleAddHYBRID_TOKEN_OFFERING_S = async () => {
    try {
      await axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_TOKEN_OFFERING_S', JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING_S)));

      const response = await axios.get('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_TOKEN_OFFERING_S');
      setHYBRID_TOKEN_OFFERING_S(response.data);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
  

    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING_S));
	Temp_Data["1"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_0"]=value;
	//handleAddHYBRID_TOKEN_OFFERING_S(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING_S']);
	Form_Data_onChange("1","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_0",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING_S(Temp_Data);
    setHYBRID_TOKEN_OFFERING_S(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING_S));
	Temp_Data["1"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_1"]=value;
	//handleAddHYBRID_TOKEN_OFFERING_S(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING_S']);
	Form_Data_onChange("1","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_1",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING_S(Temp_Data);
    setHYBRID_TOKEN_OFFERING_S(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING_S));
	Temp_Data["1"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_2"]=value;
	//handleAddHYBRID_TOKEN_OFFERING_S(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING_S']);
	Form_Data_onChange("1","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_2",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING_S(Temp_Data);
    setHYBRID_TOKEN_OFFERING_S(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING_S));
	Temp_Data["1"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_3"]=value;
	//handleAddHYBRID_TOKEN_OFFERING_S(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING_S']);
	Form_Data_onChange("1","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_3",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING_S(Temp_Data);
    setHYBRID_TOKEN_OFFERING_S(Temp_Data);
 }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING));
	Temp_Data["1"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_4"]=value;
	Form_Data_onChange("1","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_4",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING(Temp_Data);
    setHYBRID_TOKEN_OFFERING(Temp_Data);
	//handleAddHYBRID_TOKEN_OFFERING(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING']);
  }; 
  

    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING_S));
	Temp_Data["1"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_5"]=value;
	//handleAddHYBRID_TOKEN_OFFERING_S(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING_S']);
	Form_Data_onChange("1","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_5",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING_S(Temp_Data);
    setHYBRID_TOKEN_OFFERING_S(Temp_Data);
 }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_6_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_6"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING));
	Temp_Data["1"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_6"]=value;
	Form_Data_onChange("1","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_6",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING(Temp_Data);
    setHYBRID_TOKEN_OFFERING(Temp_Data);
	//handleAddHYBRID_TOKEN_OFFERING(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING']);
  }; 
  


const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING));
	Temp_Data["2"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_0"]=value;
	Form_Data_onChange("2","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_0",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING(Temp_Data);
    setHYBRID_TOKEN_OFFERING(Temp_Data);
	//handleAddHYBRID_TOKEN_OFFERING(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING']);
  }; 
  

    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING_S));
	Temp_Data["2"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_1"]=value;
	//handleAddHYBRID_TOKEN_OFFERING_S(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING_S']);
	Form_Data_onChange("2","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_1",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING_S(Temp_Data);
    setHYBRID_TOKEN_OFFERING_S(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING_S));
	Temp_Data["2"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_2"]=value;
	//handleAddHYBRID_TOKEN_OFFERING_S(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING_S']);
	Form_Data_onChange("2","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_2",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING_S(Temp_Data);
    setHYBRID_TOKEN_OFFERING_S(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING_S));
	Temp_Data["2"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_3"]=value;
	//handleAddHYBRID_TOKEN_OFFERING_S(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING_S']);
	Form_Data_onChange("2","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_3",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING_S(Temp_Data);
    setHYBRID_TOKEN_OFFERING_S(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING_S));
	Temp_Data["3"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_3_0"]=value;
	//handleAddHYBRID_TOKEN_OFFERING_S(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING_S']);
	Form_Data_onChange("3","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_3_0",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING_S(Temp_Data);
    setHYBRID_TOKEN_OFFERING_S(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING_S));
	Temp_Data["3"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_3_1"]=value;
	//handleAddHYBRID_TOKEN_OFFERING_S(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING_S']);
	Form_Data_onChange("3","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_3_1",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING_S(Temp_Data);
    setHYBRID_TOKEN_OFFERING_S(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_3_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING_S));
	Temp_Data["3"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_3_2"]=value;
	//handleAddHYBRID_TOKEN_OFFERING_S(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING_S']);
	Form_Data_onChange("3","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_3_2",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING_S(Temp_Data);
    setHYBRID_TOKEN_OFFERING_S(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING_S));
	Temp_Data["4"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_4_0"]=value;
	Form_Data_onChange("4","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_4_0",value,Temp_Data);
    setHYBRID_TOKEN_OFFERING_S(Temp_Data);
  }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING_S));
	Temp_Data["4"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_4_1"]=value;
	Form_Data_onChange("4","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_4_1",value,Temp_Data);
    setHYBRID_TOKEN_OFFERING_S(Temp_Data);
  }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_4_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_4_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING));
	Temp_Data["4"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_4_2"]=value;
	Form_Data_onChange("4","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_4_2",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING(Temp_Data);
    setHYBRID_TOKEN_OFFERING(Temp_Data);
	//handleAddHYBRID_TOKEN_OFFERING(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING']);
  }; 
  

  
      
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING_S));
	Temp_Data["7"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_0"]=value ? true : false; // optionally just use boolean
	//handleAddHYBRID_TOKEN_OFFERING_S(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING_S']);
	Form_Data_onChange("7","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_0",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING_S(Temp_Data);
    setHYBRID_TOKEN_OFFERING_S(Temp_Data);
 }; 
  



const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING));
	Temp_Data["7"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_1"]=value;
	Form_Data_onChange("7","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_1",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING(Temp_Data);
    setHYBRID_TOKEN_OFFERING(Temp_Data);
	//handleAddHYBRID_TOKEN_OFFERING(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING']);
  }; 
  


const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING));
	Temp_Data["7"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_2"]=value;
	Form_Data_onChange("7","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_2",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING(Temp_Data);
    setHYBRID_TOKEN_OFFERING(Temp_Data);
	//handleAddHYBRID_TOKEN_OFFERING(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING']);
  }; 
  

    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING_S));
	Temp_Data["7"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_3"]=value;
	//handleAddHYBRID_TOKEN_OFFERING_S(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING_S']);
	Form_Data_onChange("7","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_3",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING_S(Temp_Data);
    setHYBRID_TOKEN_OFFERING_S(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING_S));
	Temp_Data["7"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_4"]=value;
	//handleAddHYBRID_TOKEN_OFFERING_S(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING_S']);
	Form_Data_onChange("7","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_4",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING_S(Temp_Data);
    setHYBRID_TOKEN_OFFERING_S(Temp_Data);
 }; 
  
  
      
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_5_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING_S));
	Temp_Data["7"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_5"]=value ? true : false; // optionally just use boolean
	//handleAddHYBRID_TOKEN_OFFERING_S(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING_S']);
	Form_Data_onChange("7","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_5",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING_S(Temp_Data);
    setHYBRID_TOKEN_OFFERING_S(Temp_Data);
 }; 
  



const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_6_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_6"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING));
	Temp_Data["7"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_6"]=value;
	Form_Data_onChange("7","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_6",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING(Temp_Data);
    setHYBRID_TOKEN_OFFERING(Temp_Data);
	//handleAddHYBRID_TOKEN_OFFERING(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING']);
  }; 
  


const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_7_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_7"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING));
	Temp_Data["7"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_7"]=value;
	Form_Data_onChange("7","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_7",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING(Temp_Data);
    setHYBRID_TOKEN_OFFERING(Temp_Data);
	//handleAddHYBRID_TOKEN_OFFERING(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING']);
  }; 
  


const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_8_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_8"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING));
	Temp_Data["7"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_8"]=value;
	Form_Data_onChange("7","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_8",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING(Temp_Data);
    setHYBRID_TOKEN_OFFERING(Temp_Data);
	//handleAddHYBRID_TOKEN_OFFERING(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING']);
  }; 
  


const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_9_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_9"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING));
	Temp_Data["7"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_9"]=value;
	Form_Data_onChange("7","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_9",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING(Temp_Data);
    setHYBRID_TOKEN_OFFERING(Temp_Data);
	//handleAddHYBRID_TOKEN_OFFERING(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING']);
  }; 
  


const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING));
	Temp_Data["9"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_0"]=value;
	Form_Data_onChange("9","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_0",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING(Temp_Data);
    setHYBRID_TOKEN_OFFERING(Temp_Data);
	//handleAddHYBRID_TOKEN_OFFERING(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING']);
  }; 
  

    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING_S));
	Temp_Data["9"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_1"]=value;
	//handleAddHYBRID_TOKEN_OFFERING_S(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING_S']);
	Form_Data_onChange("9","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_1",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING_S(Temp_Data);
    setHYBRID_TOKEN_OFFERING_S(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING_S));
	Temp_Data["9"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_2"]=value;
	//handleAddHYBRID_TOKEN_OFFERING_S(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING_S']);
	Form_Data_onChange("9","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_2",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING_S(Temp_Data);
    setHYBRID_TOKEN_OFFERING_S(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING_S));
	Temp_Data["9"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_3"]=value;
	//handleAddHYBRID_TOKEN_OFFERING_S(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING_S']);
	Form_Data_onChange("9","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_3",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING_S(Temp_Data);
    setHYBRID_TOKEN_OFFERING_S(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_OFFERING_S));
	Temp_Data["9"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_4"]=value;
	//handleAddHYBRID_TOKEN_OFFERING_S(Temp_Data,App_Data['HYBRID_TOKEN_OFFERING_S']);
	Form_Data_onChange("9","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_4",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_OFFERING_S(Temp_Data);
    setHYBRID_TOKEN_OFFERING_S(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID) => {

};


 
   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
	selectedData = HYBRID_TOKEN_OFFERING_S.find(e => e.id == selectedRowId);
    //App_Data.Return_Data=selectedRowId;
    App_Data.Object_Return=selectedRowId;
    //console.log(event.currentTarget.querySelector('td').textContent);
    App_Data.Object_Text=selectedRowId+";"+event.currentTarget.querySelector('td').textContent;
    App_Data.Object_Id=selectedRowId;
	App_Data.Data=selectedData;
	setApp_Data({ ...App_Data})
    window.location.hash = 'Return';
   };
 
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
			  {t('Select Hybrid Token Offering')}
			  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
			</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item">
					  <a id="navbarNav1" className="nav-link" href="#Return">{t(`Return`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>		 
         {/* Search Fields*/}
         <div className="container-fluid mt-5">
            <h2  id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Advanced Search`)} <span className="toggle-icon">v</span></h2>
            <div  id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`HYBRID Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_0" type="text" className="form-control" placeholder="HYBRID Offering ID"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter HYBRID Offering ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_1" type="text" className="form-control" placeholder="Offering ID"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_2" type="text" className="form-control" placeholder="Asset ID"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`SPV ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_3" type="text" className="form-control" placeholder="SPV ID"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter SPV ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Token Type Code`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_4"   onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_4_Change} className="form-control" name="Token Type Code"  >
						  <option value="RENT_INCOME_TOKEN">RENT_INCOME_TOKEN</option>
						  <option value="REVENUE_SHARE_TOKEN">REVENUE_SHARE_TOKEN</option>
						  <option value="SALE_PROFIT_TOKEN">SALE_PROFIT_TOKEN</option>
						  <option value="EQUITY_APPRECIATION_TOKEN">EQUITY_APPRECIATION_TOKEN</option>
						  <option value="PREFERRED_EQUITY_TOKEN">PREFERRED_EQUITY_TOKEN</option>
						  <option value="COMMON_EQUITY_TOKEN">COMMON_EQUITY_TOKEN</option>
						  <option value="DEBT_NOTE_TOKEN">DEBT_NOTE_TOKEN</option>
						  <option value="HYBRID_TOKEN">HYBRID_TOKEN</option>
						  <option value="PRE_AUCTION_POOL_TOKEN">PRE_AUCTION_POOL_TOKEN</option>
						  <option value="POST_AUCTION_TOKENIZATION">POST_AUCTION_TOKENIZATION</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Token Type Code
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '180ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering Name`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_5" type="text" className="form-control" placeholder="Offering Name"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_5_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '180ch' }}>
						 {t(`Enter Offering Name`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Offering Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_6"   onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_6_Change} className="form-control" name="Offering Type"  >
						  <option value="Rental Property Offering">Rental Property Offering</option>
						  <option value="Revenue Share Offering">Revenue Share Offering</option>
						  <option value="Sale Profit Offering">Sale Profit Offering</option>
						  <option value="Equity Appreciation Offering">Equity Appreciation Offering</option>
						  <option value="Preferred Equity Offering">Preferred Equity Offering</option>
						  <option value="Common Equity Offering">Common Equity Offering</option>
						  <option value="Debt Note Offering">Debt Note Offering</option>
						  <option value="Hybrid Offering">Hybrid Offering</option>
						  <option value="Pre-Auction Pool">Pre-Auction Pool</option>
						  <option value="Post-Auction Tokenization">Post-Auction Tokenization</option>
						  <option value="Pre-Auction Pool Offering">Pre-Auction Pool Offering</option>
						  <option value="Post-Auction Tokenization Offering">Post-Auction Tokenization Offering</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Offering Type
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`SEC Exemption`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_0"   onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_0_Change} className="form-control" name="SEC Exemption"  >
						  <option value="Reg D 506(b)">Reg D 506(b)</option>
						  <option value="Reg D 506(c)">Reg D 506(c)</option>
						  <option value="Reg CF">Reg CF</option>
						  <option value="Reg A Tier 1">Reg A Tier 1</option>
						  <option value="Reg A Tier 2">Reg A Tier 2</option>
						  <option value="Section 4(a)(2)">Section 4(a)(2)</option>
						  <option value="Institutional Private Placement">Institutional Private Placement</option>
						  <option value="TBD">TBD</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter SEC Exemption
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Minimum Investment USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_1" type="text" className="form-control" placeholder="Minimum Investment USD"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Minimum Investment USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Target Offering Amount USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_2" type="text" className="form-control" placeholder="Target Offering Amount USD"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Target Offering Amount USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Maximum Offering Amount USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_3" type="text" className="form-control" placeholder="Maximum Offering Amount USD"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_3_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Maximum Offering Amount USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '20ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Token Symbol`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_3_0" type="text" className="form-control" placeholder="Token Symbol"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '20ch' }}>
						 {t(`Enter Token Symbol`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Total Tokens`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_3_1" type="text" className="form-control" placeholder="Total Tokens"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Total Tokens`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Token Price USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_3_2" type="text" className="form-control" placeholder="Token Price USD"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_3_2_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_3_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Token Price USD`)}
                     </div>
                  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Offering Start Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_4_0" type="date"   
							onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_4_0_Change} style={{ borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_4_0"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Offering Start Date
					  </div>
				  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Offering End Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_4_1" type="date"   
							onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_4_1_Change} style={{ borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_4_1"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Offering End Date
					  </div>
				  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Offering Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_4_2"   onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_4_2_Change} className="form-control" name="Offering Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Readiness Review">Readiness Review</option>
						  <option value="Open">Open</option>
						  <option value="Paused">Paused</option>
						  <option value="Closed">Closed</option>
						  <option value="Funded">Funded</option>
						  <option value="Cancelled">Cancelled</option>
						  <option value="Archived">Archived</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Offering Status
				     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Sales Map Listing Enabled`)} <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_0_Change} 
					  checked={HYBRID_TOKEN_OFFERING_S?.["7"]?.["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_0"] === "true" || HYBRID_TOKEN_OFFERING_S?.["7"]?.["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_0"] === true} />
					</label>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Sales Map Listing Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_1"   onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_1_Change} className="form-control" name="Sales Map Listing Status"  >
						  <option value="Not Listed">Not Listed</option>
						  <option value="Pre-Listing Draft">Pre-Listing Draft</option>
						  <option value="Preview Only">Preview Only</option>
						  <option value="Listed - Not Investable">Listed - Not Investable</option>
						  <option value="Listed - Investment Open">Listed - Investment Open</option>
						  <option value="Paused">Paused</option>
						  <option value="Closed">Closed</option>
						  <option value="Archived">Archived</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Sales Map Listing Status
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Sales Map First Display Trigger`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_2"   onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_2_Change} className="form-control" name="Sales Map First Display Trigger"  >
						  <option value="Asset Profile Created">Asset Profile Created</option>
						  <option value="Map Minimum Data Ready">Map Minimum Data Ready</option>
						  <option value="Offering Draft Created">Offering Draft Created</option>
						  <option value="Compliance Pre-Review Started">Compliance Pre-Review Started</option>
						  <option value="Offering Submitted">Offering Submitted</option>
						  <option value="Offering Approved">Offering Approved</option>
						  <option value="Manual Publish">Manual Publish</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Sales Map First Display Trigger
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '180ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Sales Map Public Title`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_3" type="text" className="form-control" placeholder="Sales Map Public Title"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_3_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '180ch' }}>
						 {t(`Enter Sales Map Public Title`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '1000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Sales Map Public Summary`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_4" type="text" className="form-control" placeholder="Sales Map Public Summary"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_4_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '1000ch' }}>
						 {t(`Enter Sales Map Public Summary`)}
                     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_5" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Sales Map Minimum Data Ready`)} <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_5" type="checkbox" style={{ marginLeft: '5px' }}  onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_5_Change} 
					  checked={HYBRID_TOKEN_OFFERING_S?.["7"]?.["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_5"] === "true" || HYBRID_TOKEN_OFFERING_S?.["7"]?.["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_5"] === true} />
					</label>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Sales Map Security Display Level`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_6"   onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_6_Change} className="form-control" name="Sales Map Security Display Level"  >
						  <option value="Minimal Public">Minimal Public</option>
						  <option value="Public After Compliance Precheck">Public After Compliance Precheck</option>
						  <option value="Investor Login Required">Investor Login Required</option>
						  <option value="KYC Required">KYC Required</option>
						  <option value="Accreditation Required">Accreditation Required</option>
						  <option value="Admin Only">Admin Only</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Sales Map Security Display Level
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Sales Map Risk Display Level`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_7"   onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_7_Change} className="form-control" name="Sales Map Risk Display Level"  >
						  <option value="No Risk Shown">No Risk Shown</option>
						  <option value="Color Only">Color Only</option>
						  <option value="Summary Risk">Summary Risk</option>
						  <option value="Full Risk Score">Full Risk Score</option>
						  <option value="Compliance Approved Risk Only">Compliance Approved Risk Only</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Sales Map Risk Display Level
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Sales Map Boundary Display Mode`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_8"   onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_8_Change} className="form-control" name="Sales Map Boundary Display Mode"  >
						  <option value="Show Exact Boundary">Show Exact Boundary</option>
						  <option value="Show Approximate Boundary">Show Approximate Boundary</option>
						  <option value="Show Center Pin Only">Show Center Pin Only</option>
						  <option value="Show Bounding Box">Show Bounding Box</option>
						  <option value="Hide Boundary Until Approved">Hide Boundary Until Approved</option>
						  <option value="Hide Full Location">Hide Full Location</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Sales Map Boundary Display Mode
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Sales Map Call To Action Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_9"   onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_9_Change} className="form-control" name="Sales Map Call To Action Status"  >
						  <option value="View Only">View Only</option>
						  <option value="Join Waitlist">Join Waitlist</option>
						  <option value="Request Access">Request Access</option>
						  <option value="Start KYC">Start KYC</option>
						  <option value="Reserve Interest">Reserve Interest</option>
						  <option value="Invest Now">Invest Now</option>
						  <option value="Closed">Closed</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Sales Map Call To Action Status
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_0"   onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_1" type="text" className="form-control" placeholder="Created By"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_2" type="text" className="form-control" placeholder="Created At"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_3" type="text" className="form-control" placeholder="Updated By"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_4" type="text" className="form-control" placeholder="Updated At"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
		 {/* Query Result*/}
         <div className="container-fluid mt-5">
            <h2 style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Query Result`)}</h2>
            <div className="row">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('9')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table9" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`HYBRID Offering ID`)}</th>
                        <th>{t(`Offering ID`)}</th>
                        <th>{t(`Asset ID`)}</th>
                        <th>{t(`SPV ID`)}</th>
                        <th>{t(`Token Type Code`)}</th>
                        <th>{t(`Offering Name`)}</th>
                        <th>{t(`Offering Type`)}</th>
                        <th>{t(`SEC Exemption`)}</th>
                        <th>{t(`Minimum Investment USD`)}</th>
                        <th>{t(`Target Offering Amount USD`)}</th>
                        <th>{t(`Maximum Offering Amount USD`)}</th>
                        <th>{t(`Token Symbol`)}</th>
                        <th>{t(`Total Tokens`)}</th>
                        <th>{t(`Token Price USD`)}</th>
                        <th>{t(`Offering Start Date`)}</th>
                        <th>{t(`Offering End Date`)}</th>
                        <th>{t(`Offering Status`)}</th>
                        <th>{t(`Sales Map Listing Enabled`)}</th>
                        <th>{t(`Sales Map Listing Status`)}</th>
                        <th>{t(`Sales Map First Display Trigger`)}</th>
                        <th>{t(`Sales Map Public Title`)}</th>
                        <th>{t(`Sales Map Public Summary`)}</th>
                        <th>{t(`Sales Map Minimum Data Ready`)}</th>
                        <th>{t(`Sales Map Security Display Level`)}</th>
                        <th>{t(`Sales Map Risk Display Level`)}</th>
                        <th>{t(`Sales Map Boundary Display Mode`)}</th>
                        <th>{t(`Sales Map Call To Action Status`)}</th>
                        <th>{t(`Record Status`)}</th>
                        <th>{t(`Created By`)}</th>
                        <th>{t(`Created At`)}</th>
                        <th>{t(`Updated By`)}</th>
                        <th>{t(`Updated At`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {HYBRID_TOKEN_OFFERING_S.map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_0"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_1"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_2"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_3"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_4"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_5"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_1_6"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_0"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_1"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_2"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_2_3"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_3_0"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_3_1"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_3_2"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_4_0"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_4_1"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_4_2"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_0"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_1"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_2"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_3"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_4"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_5"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_6"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_7"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_8"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_7_9"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_0"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_1"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_2"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_3"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_OFFERING_9_4"]} </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
  </>;
};

export default HYBRID_Token_Offering_S;  